<template>
  <div>
    <span :class="{'is-active':isActive}" class="hamburger" @click="toggleClick">
      <svg-icon icon-class="menu-outline" class-name="menu-icon"></svg-icon>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
.hamburger {
  display: inline-block;
  cursor: pointer;
  transform: rotate(90deg);
  transition: 0.38s;
  transform-origin: 50% 50%;
}

.hamburger.is-active {
  transform: rotate(0deg);
}
</style>
